module.exports = __webpack_public_path__ + "img/CellCycle-LICA_PLC.897e9c3b.png";